import { PREFIX_API } from 'constants/api.const';
import {
  BoothModel,
  GetBoothResponseModel,
  ApplyPinCodeRequestModel,
} from 'models/photo/booth.model';
import {
  LanguageRequestModel,
  LanguageStateModel,
} from 'models/photo/language.model';
import qs from 'query-string';
import { baseSliceApi } from './base.slice-api';

export const boothApi = baseSliceApi.injectEndpoints({
  endpoints: (build) => ({
    getBoothApiAction: build.query<BoothModel | null, void>({
      query: () => ({
        url: `${PREFIX_API.API}/booth/getbooth`,
      }),
      providesTags: () => [{ type: 'Booth' as const, id: 'LIST' }],
      extraOptions: { maxRetries: 1 },
      transformResponse: (rawResult: GetBoothResponseModel) =>
        rawResult?.response || null,
    }),
    checkPinCodeApiAction: build.mutation<boolean, ApplyPinCodeRequestModel>({
      query: (body) => ({
        url: `${PREFIX_API.API}/booth/valid-pin`,
        method: 'POST',
        body,
      }),
      extraOptions: { maxRetries: 0 },
    }),
    getLanguagesApiAction: build.query<
      LanguageStateModel['listLanguage'],
      LanguageRequestModel
    >({
      query: (payload) => ({
        url: `${PREFIX_API.API}/language/get-all?${qs.stringify(payload)}`,
      }),
      providesTags: () => [{ type: 'Language' as const, id: 'LIST' }],
      extraOptions: { maxRetries: 1 },
    }),
  }),
});

export const {
  useGetBoothApiActionQuery,
  useCheckPinCodeApiActionMutation,
  useGetLanguagesApiActionQuery,
} = boothApi;

export const {
  endpoints: {
    getBoothApiAction,
    checkPinCodeApiAction,
    getLanguagesApiAction,
  },
} = boothApi;
